import { useTranslation } from 'react-i18next';
import { useGlobalVariable } from '@api/enterprise/globalVariable';

const VARIABLE_NAME = 'HIDE_CUSTOMER_ACKNOWLEDGMENT';

type UseCustomerAcknowledgmentStatementResult = {
  statement: string;
  isLoading: boolean;
  isCustom: boolean;
};

export const useCustomerAcknowledgmentStatement =
  (): UseCustomerAcknowledgmentStatementResult => {
    const { t } = useTranslation('customerReview');
    const { data: globalVariable, isLoading } =
      useGlobalVariable(VARIABLE_NAME);

    const defaultStatement = t('acknowledgment.statement');

    let customStatement = '';
    try {
      const parsed = globalVariable?.blobText
        ? JSON.parse(globalVariable.blobText)?.statement
        : null;
      if (typeof parsed === 'string') {
        customStatement = parsed.trim();
      }
    } catch {
      customStatement = '';
    }

    const isCustom = customStatement.length > 0;

    return {
      statement: isCustom ? customStatement : defaultStatement,
      isLoading,
      isCustom
    };
  };
